<script setup lang="ts">
  import { ProgressBar } from '@/entities/Flow'
  import FlowHeader from '@/entities/Flow/components/FlowHeader/FlowHeader.vue'
  import { FlowNeedHelpWidget } from '@/widgets/Flow'
  import { BACK_EVENT_NAME } from './FlowWidget.constants'
  import {
    DEFAULT_FLOW_STEPS_COUNT,
    DEFAULT_FLOW_CURRENT_STEP,
    DEFAULT_FLOW_FIRST_STEP,
  } from '@/shared/constants/flow.constants'

  interface Props {
    href?: string
    withArrowBack?: boolean
    isRtl?: boolean
    stepsCount?: number
    currentStep?: number
    firstStep?: number
    logoAffinity?: string
  }

  interface Emits {
    (e: typeof BACK_EVENT_NAME): void
  }

  withDefaults(defineProps<Props>(), {
    withArrowBack: true,
    isRtl: false,
    stepsCount: DEFAULT_FLOW_STEPS_COUNT,
    currentStep: DEFAULT_FLOW_CURRENT_STEP,
    firstStep: DEFAULT_FLOW_FIRST_STEP,
  })

  const emit = defineEmits<Emits>()
</script>

<template>
  <div class="flow-widget">
    <div id="download-banner-container" />
    <div class="flow-widget__content">
      <FlowHeader
        :with-arrow-back="withArrowBack"
        :rtl="isRtl"
        :href="href"
        @go-back="emit('goBack')"
      />
      <ProgressBar
        v-if="(stepsCount ?? 0) > 0"
        class="flow-widget__progress"
        :steps-count="stepsCount"
        :current-step="currentStep"
        :first-step="firstStep"
      />
      <slot />
      <div class="flow-widget__footer">
        <div class="flow-widget__footer-inner">
          <template v-if="logoAffinity">
            <div class="flow-widget__affinity">
              <img :src="`data:image/png;base64,${logoAffinity}`" />
            </div>
          </template>
          <FlowNeedHelpWidget />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import './FlowWidget';
</style>
